/**
 * Lista completa de estados y municipios de México (INEGI).
 * Fuente: json-estados-municipios-mexico (datos INEGI)
 */

import rawData from './estados-municipios-raw.json';

// Nombres de estado en el JSON sin acentos -> nombres con acentos para el formulario
const MAP_ESTADO_JSON_A_FORM: Record<string, string> = {
  'Ciudad de Mexico': 'Ciudad de México',
  'Estado de Mexico': 'México',
  'Michoacan': 'Michoacán',
  'Nuevo Leon': 'Nuevo León',
  'Queretaro': 'Querétaro',
  'San Luis Potosi': 'San Luis Potosí',
  'Yucatan': 'Yucatán',
};

const raw = rawData as Record<string, string[]>;

// Construir MUNICIPIOS_POR_ESTADO con claves que coincidan con ESTADOS_MEXICO
const municipiosPorEstado: Record<string, string[]> = {};
for (const [key, municipios] of Object.entries(raw)) {
  const estadoNombre = MAP_ESTADO_JSON_A_FORM[key] || key;
  municipiosPorEstado[estadoNombre] = municipios;
}

/** Lista de los 32 estados de México (orden alfabético) */
export const ESTADOS_MEXICO = Object.keys(municipiosPorEstado).sort();

/** Todos los municipios por estado (lista completa INEGI) */
export const MUNICIPIOS_POR_ESTADO: Record<string, string[]> = municipiosPorEstado;

/** Obtener todos los municipios de un estado */
export function getMunicipiosByEstado(estado: string): string[] {
  return MUNICIPIOS_POR_ESTADO[estado] || [];
}
